export const messages = {
  verseLink: {
    id: "session-intro-block.verse-link",
    defaultMessage: "Read full verse"
  }
};
